<script setup lang="ts">
import type { ButtonColor } from '#ui/types/button'

const { $keycloak } = useNuxtApp()

const login = () => $keycloak.login()

defineProps({
  color: {
    type: String as PropType<ButtonColor>,
    default: 'white'
  }
})
</script>

<template>
  <UButton
    v-if="!$keycloak.authenticated"
    label="Login OK BPSDM"
    trailing-icon="heroicons:arrow-right-20-solid"
    :color="color"
    block
    @click="login"
  />
</template>
